<template>
  <div>
    <v-navigation-drawer app v-model="drawer" dark color="primary darken-2">
      <v-list-item class="py-3">
        <v-list-item-avatar color="white">
          <v-icon color="red darken-2">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">{{ user.surname || 'Member' }}</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip x-small color="accent" dark class="mt-1">
              {{ user.member_level ? user.member_level.toUpperCase() : 'MEMBER' }}
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>
      <v-list dense nav class="mt-1">
        <v-list-item v-for="item in navItems" :key="item.title" :to="item.to" link active-class="white--text">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider/>
        <v-list dense nav>
          <v-list-item @click="logout">
            <v-list-item-icon><v-icon color="red lighten-2">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="red--text text--lighten-2">Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar color="primary darken-2" dark app elevate-on-scroll extended extension-height="36">
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"/>
      <v-toolbar-title class="font-weight-bold subtitle-1">KANU Nominations</v-toolbar-title>
      <v-spacer/>
      <div class="hidden-sm-and-down">
        <v-btn text small exact :to="{ name: 'MemberHome' }">
          <v-icon left small>mdi-home</v-icon> Home
        </v-btn>
        <v-btn text small :to="{ name: 'MemberVoteNominate' }">
          <v-icon left small>mdi-file-document-edit</v-icon> Nominations
        </v-btn>
        <v-btn text small :to="{ name: 'MemberApplications' }">
          <v-icon left small>mdi-clipboard-list</v-icon> Applications
        </v-btn>
        <v-btn text small :to="{ name: 'MemberVoteResults' }">
          <v-icon left small>mdi-vote</v-icon> Results
        </v-btn>
        <v-btn text small @click="logout">
          <v-icon left small>mdi-logout</v-icon> Logout
        </v-btn>
      </div>

      <!-- User info strip in extension slot — no overlap, Vuetify handles the offset -->
      <template v-slot:extension>
        <div class="member-strip caption px-2" style="width:100%">
          <v-icon x-small class="mr-1">mdi-card-account-details</v-icon>
          <span class="mr-3">{{ user.membershipnumber || 'N/A' }}</span>
          <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
          <span class="mr-3">{{ user.county || 'N/A' }}</span>
          <span class="hidden-xs-only">
            <v-icon x-small class="mr-1">mdi-map</v-icon>
            <span class="mr-3">{{ user.constituency || 'N/A' }}</span>
            <v-icon x-small class="mr-1">mdi-home-map-marker</v-icon>
            <span class="mr-3">{{ user.ward || 'N/A' }}</span>
          </span>
          <v-spacer/>
          <v-chip x-small color="accent" dark class="ml-2">
            {{ user.member_level ? user.member_level.toUpperCase() : 'MEMBER' }}
          </v-chip>
        </div>
      </template>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MemberNavigation",
  data() {
    return {
      drawer: false,
      navItems: [
        { title: 'Home',          icon: 'mdi-home',               to: '/members' },
        { title: 'Nominations',   icon: 'mdi-file-document-edit', to: '/members/nominate' },
        { title: 'Applications',  icon: 'mdi-clipboard-list',     to: '/members/applications' },
        { title: 'Voting & Results', icon: 'mdi-vote',            to: '/members/results' },
      ],
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    user() { return this.getUser || {}; },
  },
  methods: {
    logout() {
      swal.fire({
        title: 'Log out?',
        text: 'You will be logged out and redirected.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c62828',
        cancelButtonColor: '#757575',
        confirmButtonText: 'Yes, log me out!',
      }).then(result => {
        if (result.value) {
          localStorage.removeItem('token');
          localStorage.removeItem('PARTYSYSTEM');
          this.$store.dispatch('logout_user');
          toast.fire('Logged out!', 'Redirecting...', 'success');
          this.$router.push('/');
        }
      });
    },
  },
};
</script>

<style scoped>
.member-strip {
  display: flex;
  align-items: center;
  opacity: 0.9;
  height: 36px;
}
</style>
